export const SET_FAVORITES = 'INSTRUMENT/SET_FAVORITES'
export const ADD_FAVORITE = 'INSTRUMENT/ADD_FAVORITE'
export const REMOVE_FAVORITE = 'INSTRUMENT/REMOVE_FAVORITE'
export const SET_ALL = 'INSTRUMENT/SET_ALL'
export const SET_CURRENCIES = 'INSTRUMENT/SET_CURRENCIES'
export const SET_SYMBOL = 'INSTRUMENT/SET_SYMBOL'
export const SET_UPDATE = 'INSTRUMENT/SET_UPDATE'
export const STOP = 'INSTRUMENT/STOP'
